import { Col, Row, Table, Card, Form, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import request from "services/request.service";
import Loader from "react-spinners/BarLoader";
import Pagination from "../components/Util/Pagination";
import { formatBeauty } from "../helpers/dateHelper";

export default function MegaPromo(props) {
  const { consumer, currentUser } = props;
  useEffect(() => {
    if (consumer) {
      getLogs();
      getGeneral();
    }
  }, [consumer]);
  const [log, setLog] = useState({
    list: [],
    pagination: {
      offset: 0,
      limit: 10,
      count: 0,
    },
    loading: false,
  });
  const [general, setGeneral] = useState({});
  const [complain, setComplain] = useState({});

  const getLogs = async (offset = 0, limit = 10) => {
    try {
      setLog((prev) => ({ ...prev, loading: true }));
      //lazy code
      const response = await request(
        `/campaign/mega/crm/log/${consumer.mobile}/${limit}/${offset}`
      );

      const data = response?.data?.data;

      setLog({
        list: data.receipts,
        pagination: {
          offset: Number(data.pagination.offset),
          limit: Number(data.pagination.limit),
          count: Number(data.pagination.count),
        },
        loading: false,
      });
    } catch (err) {
      setLog((prev) => ({ ...prev, loading: false }));
      console.log(err, "err");
    }
  };
  const getGeneral = async () => {
    try {
      //lazy code
      const response = await request(
        `/campaign/mega/crm/info/${consumer.mobile}`
      );
      setGeneral(response.data.data);
    } catch (err) {
      console.log(err, "get general error");
    }
  };
  const giveAmount = async () => {
    try {
      const response = await request(`/campaign/mega/crm/componsate`, "POST", {
        employee: currentUser.sub,
        total_amount: complain.total_amount,
        description: complain.description,
        consumer_id: `${consumer._id}`,
      });
      props.notify("tr", "success", response.data.message);

      getGeneral();
      getLogs();
      setComplain({
        total_amount: "",
        description: "",
      });
    } catch (err) {
      console.log(err, "give Amount error");
      props.notify("tr", "danger", err.message);
    }
  };
  return (
    <>
      <Col>
        <Row>
          <Col md="6">
            <Card className="striped-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">Хэрэглэгчийн мэдээлэл</Card.Title>
              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <Row>
                  <Col md="12">
                    <Table
                      className="table-hover"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      <thead>
                        <tr>
                          <th className="border-0">Нийт Дүн</th>
                          <th className="border-0">Үүссэн Огноо</th>
                          <th className="border-0">
                            Хамгийн сүүлийн гүйлгээний огноо
                          </th>
                          <th className="border-0">Нөхцөл зөвшөөрсөн эсэх</th>
                          <th className="border-0">Нөхцөл зөвшөөрсөн огноо</th>
                          <th className="border-0">Одоогийн Байр</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{general?.total_amount}</td>
                          <td>
                            {general?.created_at &&
                              formatBeauty(general?.created_at)}
                          </td>
                          <td>
                            {general?.updated_at &&
                              formatBeauty(general?.updated_at)}
                          </td>
                          <td>{general?.term_accepted ? "Тийм" : "Үгүй"}</td>
                          <td>
                            {general?.term_accepted_date &&
                              formatBeauty(general?.term_accepted_date)}
                          </td>
                          <td>{general?.rank}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                </Row>
                {log?.loading ? <Loader /> : null}
              </Card.Body>
            </Card>
          </Col>
          <Col md="6">
            <Card>
              <Card.Header>
                <Card.Title as={"h4"}>Нөхөн олгох</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    giveAmount();
                  }}
                >
                  <Form.Group controlId="lunar">
                    <label>Total_amount</label>
                    <Form.Control
                      placeholder="Receipt Total Amount"
                      as="input"
                      value={complain?.total_amount}
                      onChange={(e) => {
                        setComplain((prevState) => ({
                          ...prevState,
                          total_amount: e.target.value,
                        }));
                      }}
                      required
                    ></Form.Control>
                    <label>Дэлгэрэнгүй</label>
                    <Form.Control
                      as="input"
                      placeholder="Дэлгэрэнгүй"
                      value={complain?.description}
                      onChange={(e) => {
                        setComplain((prevState) => ({
                          ...prevState,
                          description: e.target.value,
                        }));
                      }}
                      required
                    ></Form.Control>
                    <Button
                      type="Submit"
                      style={{ marginTop: "20px" }}
                      variant="primary"
                      className="btn btn-sm"
                      size="md"
                    >
                      Олгох
                    </Button>
                  </Form.Group>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
      <Col>
        <Card>
          {log.loading ? <Loader /> : null}
          <Card.Header>
            <Card.Title as="h4">Гүйлгээ</Card.Title>
          </Card.Header>
          <Card.Body>
            <Table
              className="table-hover"
              style={{
                fontSize: "12px",
              }}
            >
              <thead>
                <tr>
                  <th>Receipt</th>
                  <th>Created Date</th>
                  <th>Receipt Total_amount</th>
                  <th>before</th>
                  <th>after</th>
                  <th>rank</th>
                </tr>
              </thead>
              <tbody>
                {log?.list?.map((col, ind) => (
                  <tr key={ind}>
                    <td>{col?.source}</td>
                    <td>{col?.created_at}</td>
                    <td>{col?.total_amount}</td>
                    <td>{col?.before}</td>
                    <td>{col?.after}</td>
                    <td>{col?.position}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <Pagination pagination={log?.pagination} onChange={getLogs} />
          </Card.Body>
        </Card>
      </Col>
    </>
  );
}
